import React, { Suspense, lazy, useContext, useEffect } from "react";
import SettingsContext from "./providers/settings_provider";
import Loader from "./components/loader";
import { Utilities } from "./services/utilities";

const PriseBulletin = lazy(() => import("./components/prise_bulletin_widget"));

const App: React.FC = () => {
  const settings = useContext(SettingsContext);
  const widgetName = settings?.widget_name;
  useEffect(() => {
    if (settings && settings.matomo_container) {
      Utilities.injectMatomoScript(settings.matomo_container);
    }
  }, [settings]);


  let WidgetComponent: React.FC;
  if (widgetName === "prise-bulletin") {
    WidgetComponent = PriseBulletin;
  } else {
    WidgetComponent = () => <div>Unsupported widget</div>;
  }

  return (
    <div className={`widget-${widgetName}`}>
      <Suspense fallback={<Loader />}>
        <WidgetComponent />
      </Suspense>
    </div>
  );
};

export default App;